interface ConsentHistory {
  action: string,
  language: string,
  status: boolean,
  timestamp: number,
  type: string,
  versions: {
    application: string,
    service: string,
    settings: string
  }
}

interface Consent {
  status: boolean,
  history: Array<ConsentHistory>
}

interface BaseService {
  categorySlug: string,
  consent: Consent,
  fetchSubServices: () => Promise<Array<any>>,
  id: string,
  isEssential: boolean,
  isHidden: boolean,
  name: string,
  processorId: string,
  subServices: Array<any>,
  subServicesLength: number,
  version: string
}

interface UserDecision {
  serviceId: string,
  status: boolean
}

type CONSENT_TYPE = 'explicit' | 'implicit';

declare global {
  interface Window {
    onYouTubeIframeAPIReady: () => void, // used for YouTubePlayer
    Intercom: any,
    SENTRY_RELEASE: {
      id: string
    },
    chrome?: {},
    app: {
      env: {
        NODE_ENV: string,
        IS_PROD: boolean,
        API_URL: string,
        COLLAB_GATEWAY_URL: string,
        RUNTIME_CONFIG_URL: string,
        CCM_LEGAL_REQUIREMENTS_TEMPLATE_URL: string,
        CLOUDINARY_CLOUD_NAME: string,
        CLOUDINARY_PRESET: string,
        GOOGLE_ANALYTICS_4_ID: string,
        INTERCOM_APP_ID: string,
        HERE_APP_ID: string,
        HERE_APP_CODE: string,
        COLLABARY_AGENCY_ID: number,
        PAGINATION_LIMIT: number,
        CAPTCHA_SITE_KEY: string,
        FEATURE_NEW_MESSAGES_POLLING: boolean,
        FEATURE_UNREAD_MESSAGES_POLLING: boolean,
        FEATURE_INTERCOM_TRACKING: boolean,
        BRAND_IDS_WITH_PERMISSION_TO_ADD_BRANDS_TO_CRAWLER: string,
        FEATURE_SERVER_SIDE_EVENTS: boolean,
        FEATURE_FACEBOOK_LOGIN: boolean
      }
    },
    UC_UI?: {
      getServicesBaseInfo: () => Array<BaseService>,
      getControllerId: () => string,
      getActiveLanguage: () => string,
      updateServices: (decisions: Array<UserDecision>, consentType?: CONSENT_TYPE) => Promise<void>,
      showFirstLayer: (target?: string) => void,
      showSecondLayer: (target?: string) => void,
      isInitialized: () => boolean,
      updateLanguage: (lang: string) => void
    }
  }
}

export default window;
